import type { PickemsCompetitor } from "@/hooks/firestore/models/pickems";
import type { BettingCompetitor } from "hooks/firestore/models/bettingCompetitor";

import appConfig from "appConfig";
import { isAppleWebView } from "@/utilities/display";
import { buildCloudinaryTransformation } from "@/utilities/sharedBettingUtilities";

export const buildCompetitorAvatarUrl = (
  competitor: BettingCompetitor | PickemsCompetitor | undefined,
  size: number,
) => {
  if (competitor && !competitor.iconUri && competitor.nationality) {
    return `${
      isAppleWebView() ? appConfig.DOMAIN : ""
    }/flags/${competitor.nationality.toLowerCase()}.png`;
  }

  return buildCloudinaryTransformation(competitor, size);
};
